window.addEventListener("load", function () {
    $(".changdua").each(function(index) {
        var $btnNhan = $(this).find(".btn-nhan");
        
        if ($(this).hasClass("received")) {
          $btnNhan.text($btnNhan.data("received"));
      } else {
          $btnNhan.text($btnNhan.data("default")) ;
      }
        
    });
  
});